module.exports = __webpack_public_path__ + "static/media/himalaya.5fca6c86.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/himalaya.gif
// module id = 374
// module chunks = 0